export default {
  eip: {
    common:{
      search: 'search',
      reset: 'reset',
      save: 'save',
      cancel: 'cancel',
      up: 'up',
      down: 'down',
      remove: 'remove',
      clear: 'clear',
      index: 'index',
      selected: 'selected'
    },
    tree:{
      filterText: 'keyword filter'
    },
    selectLang:{
      switchLang: 'switch lang'
    }
  }
};